import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel", "editLink"]
  static values = {
    defaultTab: { type: String, default: "" },
    updateUrl: { type: Boolean, default: true }
  }

  connect() {
    // Check URL param first only for tab groups that own URL tab state, then
    // default, then first tab.
    const urlParams = new URLSearchParams(window.location.search)
    const urlTab = this.updateUrlValue ? urlParams.get("tab") : null
    let defaultTab = urlTab || this.defaultTabValue || this.tabTargets[0]?.dataset.tab

    // A tab name carried over from another page (e.g. a show-page-only tab in
    // an edit link) may not exist here; fall back rather than hiding everything.
    if (defaultTab && !this.tabTargets.some(tab => tab.dataset.tab === defaultTab)) {
      defaultTab = this.defaultTabValue || this.tabTargets[0]?.dataset.tab
    }

    if (defaultTab) {
      this.show(defaultTab)
    }
  }

  select(event) {
    event.preventDefault()
    const tab = event.currentTarget.dataset.tab
    this.show(tab)
    
    // Update URL with current tab (without page reload)
    if (this.updateUrlValue) {
      const url = new URL(window.location)
      url.searchParams.set("tab", tab)
      window.history.replaceState({}, "", url)
      
      // Update any edit links to include the current tab
      this.updateEditLinks(tab)
    }
  }

  show(tabName) {
    // Update tab buttons
    this.tabTargets.forEach(tab => {
      if (tab.dataset.tab === tabName) {
        tab.classList.add("tab-active")
        tab.setAttribute("aria-selected", "true")
        // A row of tabs wider than the page scrolls; the chosen tab comes into view.
        tab.scrollIntoView({ block: "nearest", inline: "nearest" })
      } else {
        tab.classList.remove("tab-active")
        tab.setAttribute("aria-selected", "false")
      }
    })

    // Update panels
    this.panelTargets.forEach(panel => {
      if (panel.dataset.tab === tabName) {
        panel.classList.remove("hidden")
        panel.setAttribute("aria-hidden", "false")
      } else {
        panel.classList.add("hidden")
        panel.setAttribute("aria-hidden", "true")
      }
    })
  }
  
  updateEditLinks(tabName) {
    if (this.hasEditLinkTarget) {
      this.editLinkTargets.forEach(link => {
        const url = new URL(link.href)
        url.searchParams.set("tab", tabName)
        link.href = url.toString()
      })
    }
  }
}
